<template>
    <div id="history-quoter-component">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row">
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                       <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page" :total-rows="pagination.total" :per-page="pagination.per_page" aria-controls="my-table" v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                        <input id="filter-input" class="al-inputs" v-model="filter" type="search" placeholder="Buscar por palabra">
                    </div>
                    <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select" :class="[role_id===1?' offset-sm-1':'offset-sm-3']">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>

                </div>
            </div>
            <div class="row">
                <b-table sticky-header="80vh" responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="pagination.data" :filter="filter">
                    <template #cell(nombre)="{item}">
                        {{ item.nom_cont }} {{ item.paterno }} {{ item.materno }}
                    </template>
                    <template #cell(email)="{item}">
                        {{ item.email }}
                    </template>
                    <template #cell(estado)="{item}">
                        <span v-if="item.reledo">
                            {{ item.reledo.estado }}
                        </span>
                    </template>
                    <template #cell(ciudad)="{item}">
                         <span v-if="item.relcity">
                            {{ item.relcity.ciudad }}
                        </span>
                    </template>
                    <template #cell(telefono)="{item}">
                        {{ item.telefono }}
                    </template>
                    <template #cell(paquete)="{item}">
                        {{ item.relpackage.paquete }}
                    </template>
                    <template #cell(total)="{item}">
                        {{ item.prima_total }}
                    </template>
                    <template #cell(fecha)="{item}">
                        {{ item.fecha }}
                    </template>
                    <template #cell(status)="{item}">
                        <span v-if="item.approved_at!=null" class="badge rounded-pill text-bg-success">Aprobada</span>
                        <span v-else class="badge rounded-pill text-bg-secondary">Pendiente</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
        </main>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";

import {quotersService} from "../../Services/Quoters.service";


export default {
    name: "history-quoting-client",
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isBusy: false,
            modificar: false,
            filter: null,
            params: {
                limit: 10,
                page: 1,
                where: [{
                    field: 'client_id',
                    operator: '=',
                    value: this.supplier_id
                }]
            },
            fields: [
                {key: 'Nombre'},
                {key: 'email'},
                {key: 'estado'},
                {key: 'ciudad'},
                {key: 'telefono'},
                {key: 'paquete'},
                {key: 'total'},
                {key: 'fecha'},
                {key: 'status'},
                {key: 'acciones'},
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
        }
    },
    methods: {
        async index() {

            this.isBusy = true;
            this.pagination = await quotersService.getMany(this.params);
            this.isBusy = false;
        },

        changeLimit() {
            this.index();
        },

        onChange(page) {
            this.params.page = page;
            this.index();
        },
    },
    mounted() {
        //console.log('mounted');
        this.index();
    },
}
</script>

<style scoped>

.reservation-box {
    background-color: #f1f1f1;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    margin-bottom: 20px;
    padding: 15px;
    text-align: center;
}

.reservation-box .person-counter .titleCounter {
    border-bottom: 1px solid #e3e3e3;
    font-size: 12px;
    letter-spacing: .1rem;
    margin-bottom: 14px;
    margin-right: 10px;
    margin-top: 5px;
    padding-bottom: 10px;
    text-transform: uppercase;
}

.reservation-box .person-counter .amount {
    height: 25px;
    line-height: 26px;
    margin: 0 5px;
}

.reservation-box .person-counter .button {
    background-color: #fff;
    border: 0;
    border-radius: 15px;
    color: #000;
    display: inline-block;
    font-size: 14px;
    height: 25px;
    line-height: 27px;
    text-align: center;
    width: 25px;
    vertical-align: baseline;
}

.reservation-box .person-counter span.amount {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    vertical-align: bottom;
}

</style>
